import axios from './../api' // 倒入 api

// 获取所有司机列表
const getSimpleDriver = (params) => {
  return axios({
    url: '/api/driver/calendar/simple',
    method: 'GET',
    params
  })
}

//统计司机信息
const getDriverStatistic = () => {
  return axios({
    url: '/api/driver/calendar/statistics',
    method: 'GET',
  })
}

//获取车辆列表
const getSimpleVehicle = (params) => {
  return axios({
    url: '/api/car/calendar/simple',
    method: 'GET',
    params
  })
}

//统计车辆信息
const getVehicleStatistic = () => {
  return axios({
    url: '/api/car/calendar/statistics',
    method: 'GET',
  })
}

//获取车辆总览数据
const getCarCalendar = (data) => {
  return axios({
    url: '/api/car/calendar',
    method: 'POST',
    data
  })
}
//获取车辆总览数据-新
const getCarCalendarPage = (data) => {
  return axios({
    url: '/api/car/calendar/page',
    method: 'POST',
    data
  })
}
//获取车辆日历详情
const getCarCalendarDetail = (data) => {
  return axios({
    url: '/api/car/calendar/detail',
    method: 'POST',
    data
  })
}

//获取司机总览数据
const getDriverCalendar = (data) => {
  return axios({
    url: '/api/driver/calendar',
    method: 'POST',
    data
  })
}

//获取司机日历详情
const getDriverCalendarDetail = (data) => {
  return axios({
    url: '/api/driver/calendar/detail',
    method: 'POST',
    data
  })
}
// /driver/calendar/detail
// /driver/calendar/statistics

// 默认全部倒出
// 根绝需要进行
export default {
  getSimpleDriver,
  getDriverStatistic,
  getSimpleVehicle,
  getVehicleStatistic,
  getCarCalendar,
  getCarCalendarDetail,
  getDriverCalendar,
  getDriverCalendarDetail,
  getCarCalendarPage
}
